import * as PIXI from "pixi.js";
import UIBaseComponent from "@baseUI/component/base/UIBaseContainer";

export default class SimpleTextComponent extends UIBaseComponent {

    constructor(style) {
        super()
        this.pixiStyle = new PIXI.TextStyle(style)
        this.pixiText = new PIXI.Text('', this.pixiStyle)
        this.addChild(this.pixiText)

        if(this.pixiStyle.align === "center") {
            this.pixiText.anchor.set(0.5)
        } else {
            this.pixiText.anchor.set(0, 0.5)
        }
    }

    set text (value) {
        this.pixiText.text = value
    }

    get text () {
        return this.pixiText.text
    }
}